import { setFulfilled, setPending, setRejected } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import {
  EditTenantConfigurationSettingsAction,
  EditTenantConfigurationSettingsFulfilledAction,
} from '../../domains/editTenantConfigurationSettings/actions.types';
import { TenantConfigurationSettingsAction } from '../../domains/tenantConfigurationSettings/actions.types';
import { UploadTenantLogoFulfilledAction } from '../../domains/uploadTenantLogo/actions.types';

import { TenantConfigurationSettingsLifecycle } from './types';

const initialState: TenantConfigurationSettingsLifecycle = {
  pending: false,
  fulfilled: undefined,
  rejected: undefined,
};

const editTenantConfigurationSettings = (
  state: TenantConfigurationSettingsLifecycle,
  payload: EditTenantConfigurationSettingsFulfilledAction['payload']
): TenantConfigurationSettingsLifecycle => {
  const currentFulfilledState = state.fulfilled;

  if (currentFulfilledState) {
    const updatedProps = {
      ...(!!payload.editTenantConfigurationSettings?.networkDisplayName && {
        tenantName: payload.editTenantConfigurationSettings.networkDisplayName,
      }),
      ...(!!payload.editTenantConfigurationSettings?.networkLocale && {
        locale: currentFulfilledState.tenantSupportedLocale.find(
          (supportedLocale) => supportedLocale.locale === payload.editTenantConfigurationSettings?.networkLocale
        ),
      }),
      ...(!payload.editTenantConfigurationSettings?.networkLocale &&
        !payload.editTenantConfigurationSettings?.networkDisplayName && {
          tenantLogoUrl: currentFulfilledState.logoUpdated ? currentFulfilledState.pendingTenantLogoUrl : '',
          logoUpdated: false,
        }),
    };

    return {
      ...state,
      fulfilled: {
        ...currentFulfilledState,
        ...updatedProps,
      },
    };
  }

  return state;
};

const updateTenantLogoUrl = (
  state: TenantConfigurationSettingsLifecycle,
  payload: UploadTenantLogoFulfilledAction['payload']
) => {
  const currentFulfilledState = state.fulfilled;

  if (payload.mugshotTemplate && currentFulfilledState) {
    return {
      ...state,
      fulfilled: {
        ...currentFulfilledState,
        pendingTenantLogoUrl: payload.mugshotTemplate.replace('{width}x{height}', '165x'),
        logoUpdated: true,
      },
    };
  }

  return state;
};

const reducer: Reducer<
  TenantConfigurationSettingsLifecycle,
  TenantConfigurationSettingsAction | EditTenantConfigurationSettingsAction | UploadTenantLogoFulfilledAction
> = (state = initialState, action) => {
  switch (action.type) {
    case 'TENANT_CONFIGURATION_SETTINGS.LOAD_FULFILLED':
      return setFulfilled(action.payload);
    case 'TENANT_CONFIGURATION_SETTINGS.LOAD_PENDING':
      return setPending();
    case 'TENANT_CONFIGURATION_SETTINGS.LOAD_REJECTED':
      return setRejected(action.payload.error);
    case 'EDIT_TENANT_CONFIGURATION_SETTINGS.FULFILLED':
      return editTenantConfigurationSettings(state, action.payload);
    case 'UPLOAD_TENANT_LOGO.FULFILLED':
      return updateTenantLogoUrl(state, action.payload);
    default:
      return state;
  }
};

export default reducer;
